module.exports = __webpack_public_path__ + "static/media/page-next.c2215cb5.svg";